// eslint-disable-next-line import/prefer-default-export
export const HERO_AD_PLACEHOLDER = 'hero_ad_placeholder';
export const SL_WEB_LANDING_PAGE = 'sl_web_landing_page';
export const SL_WEB_MULTI_CAM_MODAL = 'sl_web_mulitcam_modal_navigation';
export const SL_WEB_PUSH_USERS_TO_APP = 'sl_web_push_users_to_app';
export const SL_WEB_SPIRIT_OF_SURFING_NAV = 'sl_web_spirit_of_surfing_nav';
export const SL_RATE_LIMITING_V3 = 'sl_rate_limiting_v3';
export const SURF_CHECK_TREATMENT_VARIANT = 'surf_check';
export const ACCOUNT_BENEFITS_TREATMENT_VARIANT = 'account_benefits';
